export class Params {
    public Id: number;
    public CompanyId: number;
    public ViewsId: number;
    public ParamsId: number;
    public Descrip: string;
    public Order: number;
    public Visibility: boolean;
    public Display: boolean;
    public Text: string;
    public Name: string;
}

/**
 * Represents the search parameters for a search operation.
 */
export interface ParamsSearch {
  /**
   * The value to search for.
   */
  SearchValue: string;

  /**
   * The page number for paginated results.
   */
  Page: number;

  /**
   * The number of records per page.
   */
  PageRecords: number;
}
